import { Component, Inject, TemplateRef, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ServicecallService } from 'src/app/services';

@Component({
  selector: 'app-file-selection-popup',
  templateUrl: './file-selection-popup.component.html',
  styleUrl: './file-selection-popup.component.css'
})
export class FileSelectionPopupComponent {

  fileTypes: string[] = [];
  file: File | null = null;
  @ViewChild('errorDialog') errorDialogTemplate!: TemplateRef<any>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<any>, public sharedService: ServicecallService, private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.fileTypes = this.data?.fileTypes;
  }

  get acceptTypes(): string {
    return this.fileTypes
      ?.map(type => type?.startsWith('.') ? type : `.${type}`)
      ?.join(',');
  }

  /**
* Uploads file
* @param event 
*/
  uploadFile(event: any) {
    const input = event.target as HTMLInputElement;
    if (!input?.files || input?.files?.length === 0) return;

    const allowedExtensions = Array.from(
      new Set(this.fileTypes?.map(ft => ft?.toLowerCase()))
    );
    const file = input.files[0];
    const ext = file?.name?.split('.')?.pop()?.toLowerCase();

    if (!ext || !allowedExtensions?.includes(ext)) {
      this.openErrorDialog(`Allowed file types: ${allowedExtensions?.join(', ')}`);
      input.value = '';
      return;
    } else {
      if (event?.target?.files?.length > 0) {
        this.file = event?.target?.files?.[0];
      }
    }
  }

  /**
   * Opens error dialog
   * @param message 
   */
  openErrorDialog(message: string): void {
    this.dialog.open(this.errorDialogTemplate, { data: message, width: '300px' });
  }

  /**
   * Attachs file
   */
  attachFile() {
    this.dialogRef?.close(this.file);
  }
}
